import React from 'react';
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {Flex, Tabs} from "antd";
import MyText from "../../../../components/UI/Text/MyText";
import TeachersList from "./List/TeachersList";
import TeachersCreate from "./Creation/TeachersCreate";

const TeachersPage = () => {

    const tabItems = [
        {
            key: '1',
            label: <IntlMessage id={'list'}/>,
            children: <TeachersList/>,
        },
        {
            key: '2',
            label: <IntlMessage id={'creation'}/>,
            children: <TeachersCreate/>,
        },
    ]

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyText uppercase strong size={"large"}><IntlMessage id={'teachers'}/></MyText>
            <Tabs style={{width: "100%"}} defaultActiveKey={"1"} type="card" items={tabItems}/>
        </Flex>
    );
};

export default TeachersPage;